import React from 'react';
import { useSearchParams } from 'react-router-dom';

export default function PageDarkLoader({ noLoaderShow }) {
  const [searchParams] = useSearchParams();
  return (
    <React.Fragment>
      <div
        className="pageLoader bg-color-base-1 fixed  inset-0 w-full h-full"
        style={{ zIndex: '9999999999999999999' }}
      >
        <div className="loaders bg-color-base-2 dark:bg-color-base-4 h-screen w-screen flex items-center flex-col justify-center gap-2 px-3">
          {!noLoaderShow && (
            <div className="load-text flex items-center gap-1 btn-shine">
              {/* <span className="fadeOut"> */}
              <svg
                width="1.1em"
                height="1.1em"
                viewBox="0 0 509 342"
                // fill="currentColor"
                // fill="url('#logo-gradient')"
                xmlns="http://www.w3.org/2000/svg"
                className="loaded-text text-color-primary"
              >
                <path
                  d="M58.0105 341.392C27.1312 338.767 1.4297 311.078 0.493964 278.889C-0.00509414 262.576 0.618729 246.262 0.244435 230.012C0.119671 225.137 2.67735 223.511 6.29551 221.949C16.651 217.574 26.2579 212.073 33.3071 202.823C51.3355 179.134 46.0954 138.445 14.2181 124.757C2.55258 119.693 -0.878448 113.319 0.182053 101.317C1.49208 86.6297 -0.628918 71.7539 1.18017 57.0029C4.48643 29.814 26.5074 6.62532 53.2694 1.56258C58.3848 0.625033 63.5002 0 68.7402 0C192.694 0 316.585 0.0625032 440.539 0C472.728 0 501.861 23.1262 507.101 53.6903C509.409 67.3162 507.038 81.254 508.224 95.005C509.534 110.068 507.101 120.006 490.819 127.131C471.792 135.444 463.246 153.883 464.93 175.384C466.428 194.198 475.723 209.573 492.69 216.698C506.228 222.386 509.596 230.262 508.286 243.825C507.038 256.263 508.286 268.889 507.849 281.389C506.789 311.828 479.278 340.08 449.647 341.455C447.276 339.517 444.407 340.33 441.787 340.33C316.461 340.33 191.135 340.33 65.8706 340.33C63.2503 340.33 60.381 339.518 57.9481 341.33L58.0105 341.392ZM254.577 328.205C316.149 328.205 377.782 328.33 439.354 328.205C472.479 328.142 494.187 305.891 494.187 272.514C494.187 262.263 493.751 251.951 494.375 241.7C494.749 235.637 492.441 233.012 487.388 230.449C465.991 219.386 453.265 201.636 451.268 177.259C448.898 148.633 462.685 124.444 488.136 111.756C492.94 109.381 494.499 106.693 494.375 101.505C494.001 89.5044 494.375 77.4413 494.187 65.3783C494.063 59.003 493.502 52.6277 490.695 46.6899C479.653 23.5012 460.751 14.1257 436.172 14.1257C315.213 14.1257 194.253 14.1257 73.2941 14.1257C70.2999 14.1257 67.3677 14.1257 64.3735 14.3132C34.8666 16.4384 14.8419 38.0644 14.7171 67.8787C14.7171 79.1918 15.0291 90.4424 14.5923 101.756C14.4052 107.131 16.2143 109.881 21.0177 111.881C27.4432 114.568 32.9951 118.881 37.9857 123.819C70.7365 155.946 62.3151 209.761 21.1425 230.637C16.2143 233.137 14.3428 235.762 14.5923 241.387C15.0914 253.388 14.7171 265.451 14.7795 277.514C14.8419 293.327 21.3921 306.141 33.3695 316.016C43.9744 324.767 56.3261 328.33 69.9253 328.33C131.497 328.267 193.13 328.33 254.702 328.33L254.577 328.205Z"
                  fill="currentColor"
                  //   fill="url('#logo-gradient')"
                />
                <path
                  d="M471.444 243.109C445.518 225.4 432.214 200.101 432.462 169.371C432.648 145.121 441.726 122.351 461.621 107.666C475.61 97.2989 478.159 85.9452 477.413 70.5192C476.294 48.6752 464.792 36.3958 442.472 36.2107C429.353 36.0873 416.235 36.6426 403.179 36.0255C396.215 35.717 395.034 38.1853 395.034 44.4792C395.283 110.936 395.159 177.455 395.096 243.973C395.096 246.626 395.781 249.403 394.164 252.612C392.112 250.822 390.309 249.28 388.569 247.614C317.754 178.997 246.939 110.319 176.125 41.7024C174.384 39.9747 172.332 38.5555 170.405 36.9511C169.411 36.766 168.478 36.3958 167.483 36.3958C132.666 36.3958 97.7878 36.3958 62.9709 36.3958C59.4272 36.3958 55.9455 36.8277 52.7126 38.3704C38.9725 42.7514 31.5118 52.5626 31.3874 66.6318C31.3253 73.8513 31.6361 81.132 31.2631 88.3515C31.0144 93.3503 32.6309 96.3738 36.9208 99.2736C83.923 131.361 89.643 197.262 46.6819 234.47C33.4391 245.948 30.4548 257.055 31.0766 272.481C31.947 293.214 44.0706 306.11 64.9604 306.358C77.5817 306.481 90.1404 305.925 102.762 306.543C109.911 306.913 112.025 305.061 112.025 297.657C111.715 235.89 111.839 174.184 111.901 112.417C111.901 109.825 111.031 107.048 113.02 103.84C124.584 114.207 135.899 124.388 147.215 134.569C209.077 190.412 270.876 246.256 332.737 302.1C335.162 304.259 337.276 306.419 341.068 306.419C375.823 306.296 410.577 306.666 445.332 306.172C464.543 305.925 477.04 292.412 477.102 273.407C477.102 266.927 476.791 260.387 477.226 253.908C477.537 248.909 475.796 245.948 471.506 242.986L471.444 243.109Z"
                  fill="currentColor"
                  //   fill="url('#logo-gradient')"
                />

                {/* <defs>
                  <linearGradient
                    id="logo-gradient"
                    // x1="50%"
                    // y1="0%"
                    // x2="50%"
                    // y2="100%"
                    x1="0"
                    y1="0"
                    x2="100%"
                    y2="100%"
                  >
                    <stop offset="0%" stopColor="#fff">
                      <animate
                        attributeName="strokecolor"
                        values="#fff; #4d4d4d; #fff"
                        dur="7s"
                        repeatCount="indefinite"
                      ></animate>
                    </stop>

                    <stop offset="60%" stopColor="#4d4d4d">
                      <animate
                        attributeName="strokecolor"
                        values="#4d4d4d; #fff; #4d4d4d"
                        dur="7s"
                        repeatCount="indefinite"
                      ></animate>
                    </stop>
                    <stop offset="100%" stopColor="#fff">
                      <animate
                        attributeName="strokecolor"
                        values="#fff; #fff; #4d4d4d"
                        dur="7s"
                        repeatCount="indefinite"
                      ></animate>
                    </stop>
                  </linearGradient>
                </defs> */}
              </svg>
              {/* </span> */}
              <div className="loading-text font-medium">nftgotix</div>
            </div>
          )}

          {(searchParams?.get('home') || searchParams?.get('slug1')) && (
            <div className="w-full flex justify-center text-center max-w-md">
              <h3 className="text-sm xl:text-lg text-color-primary">
                {searchParams?.get('home')
                  ? 'Please Wait While We Are Setting Up Your Account...'
                  : 'Please wait while we prepare your seat selection...'}
              </h3>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}
